import { useState } from 'react';
import type { HoaDonMuaDichVu } from '@/types/schemas/hoa-don-mua-dich-vu.type';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useHoaDonMuaDichVuExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportHoaDonMuaDichVuExcel, exportHoaDonMuaDichVuFromApi } = await import('../utils/export-excel');
      if (entity?.slug) {
        await exportHoaDonMuaDichVuFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportHoaDonMuaDichVuExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
